import { useQuery } from "react-query";
import { getPendingRequests } from "../api/Esop";

export interface GetAllGrantsRequest {
  planId?: string;
  grantIds?: string[];
  employeeId?: string;
  page?: number;
  pageSize?: number;
  totalPages?: number;
  total?: number;
}

export type RequestType =
  | "Vest Request"
  | "Exercise Request"
  | "Grant Created"
  | "Grant Offered"
  | "Grant For Approval";

export type PendingRequest = {
  id?: string;
  planId?: string;
  type: RequestType;
  subject: string;
  requestDate?: Date;
  exerciseDate?: Date;
  lastDate?: Date;
};

export function usePendingRequests() {
  return useQuery({
    queryKey: "pendingRequests",
    queryFn: async () => {
      const response = await getPendingRequests();
      return response.data;
    },
  });
}
